import { Order, Product } from '../swagger';

export const isHealthCheckup = (productType?: Product.TypeEnum): boolean =>
  !!productType && productType === Product.TypeEnum.HealthCheckup;

export const isOrderHealthCheckup = (order: Order): boolean =>
  order.products.some((product) => isHealthCheckup(product.type));
